export const URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000/v1';
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || 'http://localhost:3000';
export const GOOGLE_MAP_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY || 'AIzaSyCrY79nVUhPc1As6x4RBXO5Fe4GWuRk7UA';
export const USER_LOCAL_STORAGE_KEY = 'mostaza-user';
